import { render, staticRenderFns } from "./explain-search-mode-toggle.component.vue?vue&type=template&id=31264abc&scoped=true"
import script from "./explain-search-mode-toggle.component.vue?vue&type=script&lang=ts"
export * from "./explain-search-mode-toggle.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-search-mode-toggle.component.vue?vue&type=style&index=0&id=31264abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31264abc",
  null
  
)

export default component.exports